module.exports = __webpack_public_path__ + "img/restaurant_1.a9371884.jpg";